import { initConfigUnsafe } from '@cian/config/browser';
import { initGlobalEventsLogs } from '@cian/events-log';
import { init as initGlobalBehaviors } from '@cian/global-behaviors/browser';
import { initHttpApiUnsafe } from '@cian/http-api/browser';
import { initLogger } from '@cian/logger/browser';
import { registry } from '@cian/mf-registry/browser';
import { initTelemetry } from '@cian/telemetry/browser';
import { init as initWeb } from '@cian/web/browser';

import { type IApplicationContext } from '@/app/shared/types/ApplicationContext';

export type RawApplicationContext = Pick<
  IApplicationContext,
  'config' | 'httpApi' | 'logger' | 'telemetry' | 'microfrontendsRegistry'
>;

export function initDependencies(): RawApplicationContext {
  const config = initConfigUnsafe();
  const logger = initLogger();
  const httpApi = initHttpApiUnsafe();
  const telemetry = initTelemetry();

  initWeb();
  initGlobalBehaviors();
  initGlobalEventsLogs();

  return {
    config,
    httpApi,
    logger,
    telemetry,
    microfrontendsRegistry: registry(),
  };
}
